import Text from '@sendsprint/ui-react/dist/components/Text';
import React, { ReactNode, useState } from 'react';
import cs from 'classnames';

interface Props {
  variant: 'success' | 'warning' | 'error';
  label: string;
  tooltipContent?: ReactNode;
  onClick?: () => void;
  tooltipPosition?: 'top' | 'bottom';
}

const StatusBox = ({ variant, label, tooltipContent, onClick, tooltipPosition = 'top' }: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cs('ss-py-1 ss-relative ss-px-3 focus:ss-focus-ring ss-rounded-full ss-w-max', {
        'ss-bg-success-50 ss-text-success-500': variant === 'success',
        'ss-bg-error-50 ss-text-error-500': variant === 'error',
        'ss-bg-warning-50 ss-text-warning-500': variant === 'warning'
      })}>
      {isHovered && tooltipContent && (
        <Text
          className={cs(
            'ss-absolute ss-break-words ss-bg-neutral-400 ss-w-max ss-max-w-[350px] ss-px-3 ss-py-2 ss-rounded ss-text-white',
            {
              'ss-bottom-10 ss-left-0 ss-rounded-bl-none': tooltipPosition === 'top',
              'ss-top-10 ss-left-0 ss-rounded-tl-none': tooltipPosition === 'bottom'
            }
          )}>
          {tooltipContent}
        </Text>
      )}
      <Text variant="paragraphSmall">{label}</Text>
    </button>
  );
};

export default StatusBox;
